<template>
  <v-container fluid py-0 style="background-color: #E4E7EA;">
    <v-container class="myedu-content">
      <v-row align="center" justify="center">
        <v-col cols="12" md="5" sm="8">
          <v-card>
            <v-card-subtitle class="accent--text font-weight-medium text-center text-h6">{{ $t('identity_request')}}</v-card-subtitle>
            <v-card-text>
              <v-form ref="form"
                      v-model="valid"
                      lazy-validation>
                <v-text-field v-model="ime" :rules="nameRules" outlined :label="$t('enter_name')"
                              prepend-inner-icon="mdi-alphabetical" color="accent" dense></v-text-field>
                <v-text-field v-model="prezime" :rules="surnameRules" outlined :label="$t('enter_surname')"
                              prepend-inner-icon="mdi-alphabetical" color="accent" dense></v-text-field>
                <v-text-field v-model="jib" :rules="jibRules" outlined :label="$t('enter_jmbg')"
                              prepend-inner-icon="mdi-alphabetical" color="accent" dense></v-text-field>
                <v-text-field v-model="email" :rules="emailRules" outlined :label="$t('enter_email')"
                              prepend-inner-icon="mdi-at" color="accent" dense></v-text-field>
                <p class="grey--text font-weight-regular">{{ $t('identity_sub') }}</p>
                <v-btn class="text-none" block :loading="loading" color="accent" @click="validate" :disabled="loading">
                  {{ $t('identity_button') }}
                </v-btn>
              </v-form>
            </v-card-text>
            <v-card-subtitle class="red--text font-weight-regular" v-html="$t('identity_note')"></v-card-subtitle>
            <v-card-subtitle class="black--text font-weight-regular text-center">
              {{ $t('idenitity_difficulty') }}
              <v-btn class="text-none mt-2" block color="red" outlined to="/koordinatori">
                <v-icon left small>mdi-information-outline</v-icon>
                {{ $t('identity_help') }}
              </v-btn>
            </v-card-subtitle>
            <v-card-subtitle class="black--text text-center font-weight-medium">
              <img src="@/assets/edu-logo.svg"/>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title primary-title>
          <v-icon left>mdi-email-lock</v-icon>
          Preuzimanje eduID identiteta
        </v-card-title>

        <v-card-text>
          <div>{{dialog_text}}</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false; $refs.form.reset(); dialog_text = ''" color="accent" class="text-none" depressed large>U redu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        style="z-index: 999 !important; position: fixed;"
        v-model="snackbar"
        :timeout="4000"
        :value="true"
        absolute
        top
        :color="snackbar_color"
        right
    >
      {{snackbar_text}}
    </v-snackbar>
  </v-container>
</template>

<script>

export default {
  name: "preuzimanje-identiteta",
  mounted() {
    window.scroll(0,0)
  },
  methods: {
    validate() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.loading = !this.loading
        let params = {
          ime: this.ime,
          prezime: this.prezime,
          jib: this.jib,
          email: this.email
        }
        let self = this
        this.dialog_text = ''
        this.$axios.post('eduid/get', params)
            .then((res) => {
              if(res.status == 200) {
                this.dialog = true
                this.dialog_text = 'Uspješno ste preuzeli elektronički identitet eduID. Sve podatke i informacije ćete dobiti na email koji ste unijeli.'
                this.snackbar = true
                this.snackbar_text = "Uspješno!"
                this.snackbar_color = 'success'
              }
              // this.snackbar = true
              // this.snackbar_text = res
              // this.snackbar_color = 'error'
            })
            .catch(function (err) {
              console.log(err)
              self.dialog = true
              self.dialog_text = 'Dogodila se pogreška. Vaš elektronički identitet je već preuzet ili ste unijeli pogrešne podatke previše puta. Ako to niste učinili Vi, molimo Vas da se javite na referadu Vaše sastavnice.'
              self.snackbar = true
              self.snackbar_text = "Nešto je pošlo krivo!"
              self.snackbar_color = 'error'
            })
            .finally(() => {
              this.loading = false
            });
      }
    },
  },
  data: () => ({
    loading: false,
    valid: true,
    dialog: false,
    dialog_text: '',
    snackbar_text: '',
    snackbar: false,
    snackbar_color: '',
    ime: '',
    prezime: '',
    jib: '',
    email: '',
    nameRules: [
      v => !!v || 'Ime je obvezno polje',
    ],
    surnameRules: [
      v => !!v || 'Prezime je obvezno polje',
    ],
    jibRules: [
      v => !!v || 'JMBG/OIB je obvezno polje',
    ],
    emailRules: [
      v => !!v || 'Email je obvezno polje',
    ],
  }),
}
</script>

<style scoped>

</style>